import React, { useContext } from 'react';
import PageBookmarkBtn from 'components/PageBookmarkBtn/PageBookmarkBtn';
import { CronGeneratorContext, ICronGeneratorContext } from '../../../../cronGeneratorState/cronGeneratorContext';
import style from './ControlPanel.module.scss';

const ControlPanel: React.FC = () => {
	const { changeVisibleForm, visibleForm } = useContext<ICronGeneratorContext>(CronGeneratorContext);

	return (
		<div className={style.container} data-test="ControlPanel">
			{/*<PageBookmarkBtn*/}
			{/*	onClick={() => changeVisibleForm('seconds')}*/}
			{/*	isActive={visibleForm === 'seconds'}*/}
			{/*	btnName="Seconds"*/}
			{/*/>*/}
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('minutes')}
				isActive={visibleForm === 'minutes'}
				btnName="minutesBookmark"
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('hours')}
				isActive={visibleForm === 'hours'}
				btnName="hoursBookmark"
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('day')}
				isActive={visibleForm === 'day'}
				btnName="dayBookmark"
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('month')}
				isActive={visibleForm === 'month'}
				btnName="monthBookmark"
			/>
			{/*<PageBookmarkBtn*/}
			{/*	onClick={() => changeVisibleForm('year')}*/}
			{/*	isActive={visibleForm === 'year'}*/}
			{/*	btnName="Year"*/}
			{/*/>*/}
		</div>
	);
};

export default ControlPanel;
